import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_STEP_REQUEST = 'preset/GET_STEP_REQUEST'
const GET_STEP_SUCCESS = 'preset/GET_STEP_SUCCESS'
const GET_STEP_FAILURE = 'preset/GET_STEP_FAILURE'

const CREATE_STEP_REQUEST = 'preset/CREATE_STEP_REQUEST'
const CREATE_STEP_SUCCESS = 'preset/CREATE_STEP_SUCCESS'
const CREATE_STEP_FAILURE = 'preset/CREATE_STEP_FAILURE'

const UPDATE_STEP_REQUEST = 'preset/UPDATE_STEP_REQUEST'
const UPDATE_STEP_SUCCESS = 'preset/UPDATE_STEP_SUCCESS'
const UPDATE_STEP_FAILURE = 'preset/UPDATE_STEP_FAILURE'

const DELETE_STEP_REQUEST = 'preset/DELETE_STEP_REQUEST'
const DELETE_STEP_SUCCESS = 'preset/DELETE_STEP_SUCCESS'
const DELETE_STEP_FAILURE = 'preset/DELETE_STEP_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  step: [],
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STEP_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_STEP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        step: action.payload
      }
    case GET_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_STEP_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_STEP_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_STEP_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_STEP_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_STEP_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_STEP_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }

}

// Action Creators
export const getStep = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_STEP_REQUEST
      })

      const response = await API.get(EndPoints.STEP + `/groupByStepType`)
      dispatch({
        type: GET_STEP_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_STEP_FAILURE
      })
    }
  }
}
export const createStep = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_STEP_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.STEP + `/createStep`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_STEP_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_STEP_FAILURE
      })
    }
  }
}
export const updateStep = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_STEP_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.STEP + `/updateStep`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_STEP_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_STEP_FAILURE
      })
    }
  }
}
export const deleteStep = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_STEP_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.STEP + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_STEP_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_STEP_FAILURE
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/modules/step.js